import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';
import type { AnimationPreference } from 'owa-outlook-service-option-store';

export const setAnimationPropertiesMutator: (
    shouldAnimate: boolean,
    animationPreference: AnimationPreference
) => void = mutatorAction(
    'setAnimationPropertiesMutator',
    (shouldAnimate: boolean, animationPreference: AnimationPreference): void => {
        const animationStore = getStore();
        animationStore.shouldAnimate = shouldAnimate;
        animationStore.animationPreference = animationPreference;
    }
);
